import React from 'react';
import { Redirect } from 'react-router-dom';
import { PRODUCT_TYPES } from '@config/app.constants';
import { WORKFLOW_STATUS } from '@domain/Briefing';
import { routes } from '@infrastructure/routing/routes';
import { goToProductList } from '@infrastructure/routing/helpers';
import { ErecruitingSourcingServiceProductType } from '@interfaces/xingOne';

type Keys = keyof typeof WORKFLOW_STATUS;
type WorkflowStatuses = typeof WORKFLOW_STATUS[Keys];

type PAGES = 'longlist' | 'shortlist';

export type BriefingGateKeeperProps = {
  currentPage: PAGES;
  currentProduct?: ErecruitingSourcingServiceProductType;
  currentBriefingId?: string;
  currentWorkflowStatus?: WorkflowStatuses;
};

// Place BriefingGateKeeper at the beginning of the render/return
const BriefingGateKeeper = ({
  currentPage,
  currentProduct,
  currentBriefingId,
  currentWorkflowStatus,
}: BriefingGateKeeperProps) => {
  // RULES
  const canSeeShortlist =
    currentPage === PRODUCT_TYPES.longlist &&
    currentProduct === ErecruitingSourcingServiceProductType.Shortlist;

  const canSeeLonglist =
    currentPage === PRODUCT_TYPES.shortlist &&
    currentProduct === ErecruitingSourcingServiceProductType.Longlist;

  const isNotLonglistFinalState =
    currentWorkflowStatus &&
    currentPage === PRODUCT_TYPES.longlist &&
    currentWorkflowStatus !== WORKFLOW_STATUS.FINAL_PRESENTATION;

  const isNotShortlistReady =
    currentWorkflowStatus &&
    currentPage === PRODUCT_TYPES.shortlist &&
    ![
      WORKFLOW_STATUS.FINAL_PRESENTATION,
      WORKFLOW_STATUS.SECOND_SCREENING,
    ].includes(currentWorkflowStatus as any);

  // ACTIONS
  if (isNotLonglistFinalState || isNotShortlistReady) {
    return <Redirect to={routes.briefingsDashboard} />;
  }

  if (canSeeShortlist || canSeeLonglist) {
    if (!currentBriefingId) {
      throw new Error('BriefingGateKeeper requires briefingId');
    }

    return (
      <Redirect
        to={goToProductList({
          briefingId: currentBriefingId,
          prodType: currentProduct.toLocaleLowerCase() as PRODUCT_TYPES,
        })}
      />
    );
  }

  return null;
};

export { BriefingGateKeeper };
